import { DocumentText1, Trash } from "iconsax-react";
import React, { useState } from "react";
import * as RB from "react-bootstrap";
import Swal from "sweetalert2";
import * as utils from "../../Utils/comman";

function MultiFileUpload({
  setFileUploads,
  fileUploads,
  EditfileUploads,
  setEditFileUploads,
  isSameUser,
  status,
}) {
  const [errorMessages, setErrorMessages] = useState({
    meetingPhotos: "",
    artisanData: "",
    meetingExpenses: "",
    expenseBills: "",
  });

  const fileExtensions = {
    meetingPhotos: ["jpg", "jpeg", "png", "pdf"],
    artisanData: ["jpg", "jpeg", "png", "pdf", "xls", "xlsx"],
    meetingExpenses: ["jpg", "jpeg", "png", "pdf", "xls", "xlsx"],
    expenseBills: ["jpg", "jpeg", "png", "pdf", "xls", "xlsx"],
  };

  const handleFileUpload = (e, category) => {
    const files = Array.from(e.target.files);

    const validFiles = validateFiles(files, category);

    if (validFiles.length !== files.length) {
      setErrorMessages((prev) => ({
        ...prev,
        [category]: `Only ${fileExtensions[category]
          .join(", ")
          .toUpperCase()} files are allowed.`,
      }));
      return;
    } else {
      setErrorMessages((prev) => ({
        ...prev,
        [category]: "",
      }));
    }

    const oversizedFiles = validFiles.filter(
      (file) => file.size > 2 * 1024 * 1024,
    ); // 2MB limit

    if (oversizedFiles.length > 0) {
      Swal.fire({
        title: "File Size Exceeded!",
        text: `The following files are too large (max 2MB each): \n${oversizedFiles
          .map((file) => file.name)
          .join(", ")}`,
        icon: "error",
      });
      return;
    }

    setFileUploads((prev) => ({
      ...prev,
      [category]: [...(prev[category] || []), ...validFiles],
    }));
  };

  const validateFiles = (files, category) => {
    const allowedExtensions = fileExtensions[category] || [];

    return files.filter((file) => {
      const fileName = file.name || "";
      const extension = fileName.split(".").pop().toLowerCase();

      // Allow only files which match the allowed extensions strictly
      return allowedExtensions.includes(extension);
    });
  };

  const handleRemoveFile = (file, category) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setFileUploads((prev) => ({
          ...prev,
          [category]: prev[category].filter((f) => f !== file),
        }));
      }
    });
  };

  const handleRemoveEditFile = (file, category) => {
    console.log(file);
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const updatedFiles = EditfileUploads?.[category]?.map((f) =>
          f.id === file.id ? { ...f, isDeleted: true } : f,
        );

        setEditFileUploads((prev) => ({
          ...prev,
          [category]: updatedFiles,
        }));

        utils
          .callAPI("get", `meeting/document-delete?id=${file?.id}`, "")
          .then((res) => {
            if (typeof res !== "undefined") {
              // getMeetings();
            }
          })
          .catch((err) => {});
      }
    });
  };

  const getIconForFileType = (file) => {
    const fileExtension = file.attachPath.split(".").pop().toLowerCase();

    // Check the file extension and return the corresponding icon
    if (fileExtension === "pdf") {
      return <i className="material-icons md-96">picture_as_pdf</i>;
    } else if (fileExtension === "doc" || fileExtension === "docx") {
      return <i className="material-icons md-96">description</i>;
    } else if (fileExtension === "xls" || fileExtension === "xlsx") {
      return <i className="material-icons md-96">description</i>;
    } else if (fileExtension === "jpeg" || fileExtension === "jpg") {
      return <i className="material-icons md-96">image</i>;
    } else {
      return <i className="material-icons md-96">file_copy</i>; // default icon for unsupported types
    }
  };

  const handleDownload = async (fileUrl, fileName) => {
    try {
      const response = await fetch(fileUrl, { mode: "cors" });
      if (!response.ok) throw new Error("Network response was not ok");

      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", fileName || "download");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
    } catch (error) {
      // Fallback if CORS prevents fetch
      window.open(fileUrl, "_blank");
    }
  };

  return (
    <>
      <RB.Col md={12}>
        <div className="mb-3">
          <label className="form-label">
            Meeting Photos (JPEG/JPG/PNG/PDF)
          </label>
          {!isSameUser ||
            (status !== 8 && (
              <RB.Form.Control
                type="file"
                multiple
                accept=".jpg,.jpeg,.png,.pdf"
                onChange={(e) => handleFileUpload(e, "meetingPhotos")}
              />
            ))}
          <RB.Row className="mt-3 g-3">
            {fileUploads.meetingPhotos.map((file, index) => {
              const ext = file.name.split(".").pop().toLowerCase();
              const isImage = ["jpg", "jpeg", "png"].includes(ext);

              return (
                <RB.Col key={index} className="col-md-3 col-lg-2">
                  <div className="position-relative mb-4 text-center">
                    <div
                      className="product-image-upload mb-3"
                      style={{ height: "150px" }}
                    >
                      <a
                        href={URL.createObjectURL(file)}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {isImage ? (
                          <img
                            src={URL.createObjectURL(file)}
                            alt={`Image ${index}`}
                            className="img-fluid rounded"
                          />
                        ) : (
                          <>
                            <i className="material-icons md-96">
                              picture_as_pdf
                            </i>
                            <span className="d-block mt-2 text-truncate">
                              {file.name}
                            </span>
                          </>
                        )}
                      </a>
                    </div>
                    {isSameUser && status !== 8 && (
                      <RB.Button
                        variant="danger"
                        className="btn btn-sm btn-circle position-absolute top-100 start-50 translate-middle"
                        onClick={() => handleRemoveFile(file, "meetingPhotos")}
                      >
                        <i className="material-icons-outlined">delete</i>
                      </RB.Button>
                    )}
                  </div>
                </RB.Col>
              );
            })}

            {EditfileUploads?.meetingPhotos
              ?.filter((file) => !file.isDeleted)
              .map((file, index) => {
                const ext = file.attachPath?.split(".").pop()?.toLowerCase();
                const isImage = ["jpg", "jpeg", "png"].includes(ext);

                return (
                  <RB.Col key={index} className="col-md-3 col-lg-2">
                    <div className="position-relative mb-4 text-center">
                      <div
                        className="product-image-upload mb-3"
                        style={{ height: "150px" }}
                      >
                        <a
                          href={file.attachPath}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {isImage ? (
                            <img
                              src={file.attachPath}
                              alt={`Image ${index}`}
                              className="img-fluid rounded"
                            />
                          ) : (
                            <>
                              <i className="material-icons md-96">
                                picture_as_pdf
                              </i>
                              <span className="d-block mt-2 text-truncate">
                                {file.filename}
                              </span>
                            </>
                          )}
                        </a>
                      </div>
                      <div className="d-flex justify-content-center gap-2 position-absolute top-100 start-50 translate-middle mt-2">
                        <RB.Button
                          variant="primary"
                          className="btn btn-sm btn-circle mt-4"
                          title="Download"
                          onClick={() =>
                            handleDownload(file.attachPath, file.filename)
                          }
                        >
                          <i className="material-icons-outlined">
                            file_download
                          </i>
                        </RB.Button>

                        {isSameUser && status !== 8 && (
                          <RB.Button
                            variant="danger"
                            className="btn btn-sm btn-circle position-absolute top-100 start-50 translate-middle"
                            onClick={() =>
                              handleRemoveEditFile(file, "meetingPhotos")
                            }
                          >
                            <i className="material-icons-outlined">delete</i>
                          </RB.Button>
                        )}
                      </div>
                    </div>
                  </RB.Col>
                );
              })}
          </RB.Row>
        </div>
      </RB.Col>

      <RB.Col md={12}>
        <div className="mb-3">
          <label className="form-label">
            Artisan Data (JPEG,JPG,PNG, PDF, Excel)
          </label>
          {!isSameUser ||
            (status !== 8 && (
              <RB.Form.Control
                type="file"
                multiple
                accept=".jpg,.jpeg,.png,.pdf,.xls,.xlsx"
                onChange={(e) => handleFileUpload(e, "artisanData")}
                // disabled={!isSameUser}
              />
            ))}
          <RB.Row className="mt-3 g-3">
            {/* Uploaded Files */}
            {fileUploads.artisanData.map((file, index) => {
              const ext = file.name.split(".").pop().toLowerCase();
              const isImage = ["jpg", "jpeg", "png"].includes(ext);

              return (
                <RB.Col key={index} className="col-md-3 col-lg-2">
                  <div className="position-relative mb-4 text-center">
                    <div
                      className="product-image-upload mb-3"
                      style={{ height: "150px" }}
                    >
                      <a
                        href={URL.createObjectURL(file)}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {isImage ? (
                          <img
                            src={URL.createObjectURL(file)}
                            alt={`Image ${index}`}
                            className="img-fluid rounded"
                          />
                        ) : (
                          <>
                            <i className="material-icons md-96">description</i>
                            <span className="d-block mt-2 text-truncate">
                              {file.name}
                            </span>
                          </>
                        )}
                      </a>
                    </div>
                    {isSameUser && status !== 8 && (
                      <RB.Button
                        variant="danger"
                        className="btn btn-sm btn-circle position-absolute top-100 start-50 translate-middle"
                        onClick={() => handleRemoveFile(file, "artisanData")}
                      >
                        <i className="material-icons-outlined">delete</i>
                      </RB.Button>
                    )}
                  </div>
                </RB.Col>
              );
            })}

            {/* Edited Files */}
            {EditfileUploads?.artisanData
              ?.filter((file) => !file.isDeleted)
              .map((file, index) => {
                const ext = file.attachPath?.split(".").pop()?.toLowerCase();
                const isImage = ["jpg", "jpeg", "png"].includes(ext);

                return (
                  <RB.Col key={index} className="col-md-3 col-lg-2">
                    <div className="position-relative mb-4 text-center">
                      <div
                        className="product-image-upload mb-3"
                        style={{ height: "150px" }}
                      >
                        <a
                          href={file.attachPath}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {isImage ? (
                            <img
                              src={file.attachPath}
                              alt={`Image ${index}`}
                              className="img-fluid rounded"
                            />
                          ) : (
                            <>
                              <i className="material-icons md-96">
                                description
                              </i>
                              <span className="d-block mt-2 text-truncate">
                                {file.filename}
                              </span>
                            </>
                          )}
                        </a>
                      </div>
                      <div className="d-flex justify-content-center gap-2 position-absolute top-100 start-50 translate-middle mt-2">
                        <RB.Button
                          variant="primary"
                          className="btn btn-sm btn-circle mt-4"
                          title="Download"
                          onClick={() =>
                            handleDownload(file.attachPath, file.filename)
                          }
                        >
                          <i className="material-icons-outlined">
                            file_download
                          </i>
                        </RB.Button>
                        {isSameUser && status !== 8 && (
                          <RB.Button
                            variant="danger"
                            className="btn btn-sm btn-circle position-absolute top-100 start-50 translate-middle"
                            onClick={() =>
                              handleRemoveEditFile(file, "artisanData")
                            }
                          >
                            <i className="material-icons-outlined">delete</i>
                          </RB.Button>
                        )}
                      </div>
                    </div>
                  </RB.Col>
                );
              })}
          </RB.Row>
        </div>
      </RB.Col>

      <RB.Col md={12}>
        <div className="mb-3">
          <label className="form-label">
            Meeting Expenses Form (JPEG, JPG, PNG, PDF, Excel)
          </label>
          {!isSameUser ||
            (status !== 8 && (
              <RB.Form.Control
                type="file"
                multiple
                accept=".jpg,.jpeg,.png,.pdf,.xls,.xlsx"
                onChange={(e) => handleFileUpload(e, "meetingExpenses")}
              />
            ))}
          <RB.Row className="mt-3 g-3">
            {/* Uploaded Files */}
            {fileUploads.meetingExpenses.map((file, index) => {
              const ext = file.name.split(".").pop().toLowerCase();
              const isImage = ["jpg", "jpeg", "png"].includes(ext);

              return (
                <RB.Col key={index} className="col-md-3 col-lg-2">
                  <div className="position-relative mb-4 text-center">
                    <div
                      className="product-image-upload mb-3"
                      style={{ height: "150px" }}
                    >
                      <a
                        href={URL.createObjectURL(file)}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {isImage ? (
                          <img
                            src={URL.createObjectURL(file)}
                            alt={`Image ${index}`}
                            className="img-fluid rounded"
                          />
                        ) : (
                          <>
                            <i className="material-icons md-96">description</i>
                            <span className="d-block mt-2 text-truncate">
                              {file.name}
                            </span>
                          </>
                        )}
                      </a>
                    </div>
                    {isSameUser && status !== 8 && (
                      <RB.Button
                        variant="danger"
                        className="btn btn-sm btn-circle position-absolute top-100 start-50 translate-middle"
                        onClick={() =>
                          handleRemoveFile(file, "meetingExpenses")
                        }
                      >
                        <i className="material-icons-outlined">delete</i>
                      </RB.Button>
                    )}
                  </div>
                </RB.Col>
              );
            })}

            {/* Edited Files */}
            {EditfileUploads?.meetingExpenses
              ?.filter((file) => !file.isDeleted)
              .map((file, index) => {
                const ext = file.attachPath?.split(".").pop()?.toLowerCase();
                const isImage = ["jpg", "jpeg", "png"].includes(ext);

                return (
                  <RB.Col key={index} className="col-md-3 col-lg-2">
                    <div className="position-relative mb-4 text-center">
                      <div
                        className="product-image-upload mb-3"
                        style={{ height: "150px" }}
                      >
                        <a
                          href={file.attachPath}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {isImage ? (
                            <img
                              src={file.attachPath}
                              alt={`Image ${index}`}
                              className="img-fluid rounded"
                            />
                          ) : (
                            <>
                              <i className="material-icons md-96">
                                description
                              </i>
                              <span className="d-block mt-2 text-truncate">
                                {file.filename}
                              </span>
                            </>
                          )}
                        </a>
                      </div>
                      <div className="d-flex justify-content-center gap-2 position-absolute top-100 start-50 translate-middle mt-2">
                        <RB.Button
                          variant="primary"
                          className="btn btn-sm btn-circle mt-4"
                          title="Download"
                          onClick={() =>
                            handleDownload(file.attachPath, file.filename)
                          }
                        >
                          <i className="material-icons-outlined">
                            file_download
                          </i>
                        </RB.Button>
                        {isSameUser && status !== 8 && (
                          <RB.Button
                            variant="danger"
                            className="btn btn-sm btn-circle position-absolute top-100 start-50 translate-middle"
                            onClick={() =>
                              handleRemoveEditFile(file, "meetingExpenses")
                            }
                          >
                            <i className="material-icons-outlined">delete</i>
                          </RB.Button>
                        )}
                      </div>
                    </div>
                  </RB.Col>
                );
              })}
          </RB.Row>
        </div>
      </RB.Col>

      <RB.Col md={12}>
        <div className="mb-3">
          <label className="form-label">
            Expense Bills (JPEG, JPG, PNG, PDF, Excel)
          </label>
          {!isSameUser ||
            (status !== 8 && (
              <RB.Form.Control
                type="file"
                multiple
                accept=".jpg,.jpeg,.png,.pdf,.xls,.xlsx"
                onChange={(e) => handleFileUpload(e, "expenseBills")}
              />
            ))}

          <RB.Row className="mt-3 g-3">
            {/* Uploaded Files */}
            {fileUploads.expenseBills.map((file, index) => {
              const ext = file.name.split(".").pop().toLowerCase();
              const isImage = ["jpg", "jpeg", "png"].includes(ext);

              return (
                <RB.Col key={index} className="col-md-3 col-lg-2">
                  <div className="position-relative mb-4 text-center">
                    <div
                      className="product-image-upload mb-3"
                      style={{ height: "150px" }}
                    >
                      <a
                        href={URL.createObjectURL(file)}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {isImage ? (
                          <img
                            src={URL.createObjectURL(file)}
                            alt={`Image ${index}`}
                            className="img-fluid rounded"
                          />
                        ) : (
                          <>
                            <i className="material-icons md-96">
                              {ext === "pdf" ? "picture_as_pdf" : "description"}
                            </i>
                            <span className="d-block mt-2 text-truncate">
                              {file.name}
                            </span>
                          </>
                        )}
                      </a>
                    </div>
                    {isSameUser && status !== 8 && (
                      <RB.Button
                        variant="danger"
                        className="btn btn-sm btn-circle position-absolute top-100 start-50 translate-middle"
                        onClick={() => handleRemoveFile(file, "expenseBills")}
                      >
                        <i className="material-icons-outlined">delete</i>
                      </RB.Button>
                    )}
                  </div>
                </RB.Col>
              );
            })}

            {/* Edited Files */}
            {EditfileUploads?.expenseBills
              ?.filter((file) => !file.isDeleted)
              .map((file, index) => {
                const ext = file.attachPath?.split(".").pop()?.toLowerCase();
                const isImage = ["jpg", "jpeg", "png"].includes(ext);

                return (
                  <RB.Col key={index} className="col-md-3 col-lg-2">
                    <div className="position-relative mb-4 text-center">
                      <div
                        className="product-image-upload mb-3"
                        style={{ height: "150px" }}
                      >
                        <a
                          href={file.attachPath}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {isImage ? (
                            <img
                              src={file.attachPath}
                              alt={`Image ${index}`}
                              className="img-fluid rounded"
                            />
                          ) : (
                            <>
                              <i className="material-icons md-96">
                                {ext === "pdf"
                                  ? "picture_as_pdf"
                                  : "description"}
                              </i>
                              <span className="d-block mt-2 text-truncate">
                                {file.filename}
                              </span>
                            </>
                          )}
                        </a>
                      </div>
                      <div className="d-flex justify-content-center gap-2 position-absolute top-100 start-50 translate-middle mt-2">
                        <RB.Button
                          variant="primary"
                          className="btn btn-sm btn-circle mt-4"
                          title="Download"
                          onClick={() =>
                            handleDownload(file.attachPath, file.filename)
                          }
                        >
                          <i className="material-icons-outlined">
                            file_download
                          </i>
                        </RB.Button>
                        {isSameUser && status !== 8 && (
                          <RB.Button
                            variant="danger"
                            className="btn btn-sm btn-circle position-absolute top-100 start-50 translate-middle"
                            onClick={() =>
                              handleRemoveEditFile(file, "expenseBills")
                            }
                          >
                            <i className="material-icons-outlined">delete</i>
                          </RB.Button>
                        )}
                      </div>
                    </div>
                  </RB.Col>
                );
              })}
          </RB.Row>
        </div>
      </RB.Col>
    </>
  );
}

export default MultiFileUpload;
